<template>
  <div>
    <!-- Top banner -->
    <div class="banner" v-bind:style="{ backgroundImage: 'url(' + 'https://ocs-sport.ams3.digitaloceanspaces.com/cpt/2026/06/newimproved.png' + ')' }">
        <h1 class="majorHeading container">THE RETURN OF<br> ELITE GOLF TO  <br> <span class="englishColors">ENGLAND</span></h1>
        <h2 class="subHeading container">10–13 September 2026 | The Caversham</h2>
        <p class="paraHeading container">The English Trophy brings world-class professional golf <br>back to England in partnership with the HotelPlanner Tour,<br>
            creating a tournament designed to showcase the next generation of stars<br> on their pathway to the DP World Tour. </p>
        <b-container>
            <b-row class="buttonsAlign">
                <b-col lg="6">
                    <b-row>
                        <b-col>
                            <b-link href="https://buytickets.at/theclutchtour/2259699" class="allNewsLink" target="_blank">
                                <button class="Allbuttons" :style="colourTour">
                                    Buy Tickets
                                </button>
                                <!-- <button class="AllbuttonsNone" :style="colourTour" disabled>
                                    Buy Tickets
                                </button> -->
                            </b-link>
                        </b-col>
                        <b-col>
                            <button
                                class="Allbuttons newbtn"
                                :style="colourTour"
                                @click="scroll()"
                            >
                                Become a Sponsor
                            </button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <img class="trophyImage" src="https://ocs-sport.ams3.digitaloceanspaces.com/cpt/2026/06/ui-site-header-sky-sports-logo.png">
        <img class="trophyImage" src="https://ocs-sport.ams3.digitaloceanspaces.com/cpt/2026/06/new.jpg">
        <img class="trophyImage" src="https://ocs-sport.ams3.digitaloceanspaces.com/cpt/2026/06/el.png">
    </div>
    <!--Green Banner Below image -->
    <div class="backgroundGreen hideMob">
        <div class="row container rowClass">
            <b-col v-for="(top, index) in acf.acf.banner_row" :key="index + 'topRow'">
                <div class="bannerBlock">
                    <b-row>
                        <b-col sm="12" md="12" lg='4'>
                            <img class="bannerImage" :src="top.image">
                        </b-col>
                        <b-col sm="12" md="12" lg='8'>
                            <h1 class="bannerTitle">{{top.title}}</h1>
                            <h2 class="bannerText-b">{{top.text}}</h2>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </div>
    </div>
    <!-- Events Highlights -->
    <div class="greybackground Above1201">
        <b-container>
            <h1 class="heading">EVENTS HIGHTLIGHTS</h1>
            <b-row>
                <b-col v-for="(event, index) in acf.acf.event_section" :key="index + 'event'" class="whiteBK">
                    <div class="backgroundTicketWhite">
                        <img class="eventImage" :src="event.event_image">
                        <h1 class="eventTitle">{{event.event_title}}</h1>
                        <p class="eventLineOne">{{event.event_line_one}}</p>
                        <p class="eventLineTwo">{{event.event_line_two}}</p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
    <div class="greybackground Below1200">
        <b-container>
            <h1 class="heading">EVENTS HIGHTLIGHTS</h1>
            <b-row>
                <b-col lg="12" v-for="(event, index) in acf.acf.event_section" :key="index + 'event'" class="whiteBK" style="margin-bottom:12px">
                    <div class="backgroundTicketWhite">
                        <img class="eventImage" :src="event.event_image">
                        <h1 class="eventTitle">{{event.event_title}}</h1>
                        <p class="eventLineOne">{{event.event_line_one}}</p>
                        <p class="eventLineTwo">{{event.event_line_two}}</p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>

    <!-- Why this event matters -->
    <div class="blueBanner">
        <b-container>
            <h1 class="heading whythismatters">WHY THIS EVENT MATTERS</h1>
            <img src="https://ocs-sport.ams3.digitaloceanspaces.com/cpt/2026/06/trans.png" class="eventLogo">
            <h1 class="BannerText">
                The English Trophy represents the return of elite pathway golf to England and serves as a direct stepping stone toward the DP World Tour.  
                The tournament also champions accessibility and grassroots development through dedicated junior initiatives and inclusive fan experiences.  
                Built by Clutch Pro Tour — Europe & MENA’s leading development tour — the event combines elite competition with modern sports entertainment, digital storytelling and global media reach.
            </h1>
        </b-container>
    </div>
    <!-- Tickets -->
    <div class="backgroundGreen ticketSec"
        :style="{
            backgroundImage:
            'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/05/ChatGPT-Image-May-19-2026-03_28_18-PM.png)'
        }"
    >
        <b-container>
            <h1 class="heading" style="color:#fff">TICKETS</h1>
            <b-row class="Above1201">
                <b-col v-for="(tic, index) in acf.acf.ticket_section"
                    :key="index + 'ticket'">
                    <div
                        :style="{
                        backgroundImage:
                            'url(' + tic. ticket_image+ ')'
                        }"
                        class="ticketCol"
                    >
                    </div>
                    <div class="whiteback">
                        <h1 class="TicketTitle">{{ tic.ticket_title }}</h1>

                        <h2 class="ticktText" v-html="tic.ticket_sub_text"></h2>

                        <p class="ticketPara" v-html="tic.ticket_points"></p>
                    </div>
                </b-col>
            </b-row>
            <b-row class="Below1200">
                <b-col lg="12" v-for="(tic, index) in acf.acf.ticket_section"
                    :key="index + 'ticket'">
                    <div
                        :style="{
                        backgroundImage:
                            'url(' + tic. ticket_image+ ')'
                        }"
                        class="ticketCol"
                    >
                    </div>
                    <div class="whiteback">
                        <h1 class="TicketTitle">{{ tic.ticket_title }}</h1>

                        <h2 class="ticktText" v-html="tic.ticket_sub_text"></h2>

                        <p class="ticketPara" v-html="tic.ticket_points"></p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
    <!-- Become a sponsor -->
    <div class="greybackground">
        <h1 class="heading" id="sponsorBlo">BECOME A SPONSOR</h1>
        <p class="para container">Align your brand with the future stars of golf. A rang of partnership packages are available<br>
        to suit your business objectives and maximise your brand exposure</p>
        <a class="partner" href="mailto:partnership@clutchprotour.co.uk">partnership@clutchprotour.co.uk</a>
        <b-container>
            <b-row class="Above1201">
                <b-col
                    class="sponCol"
                    v-for="(spon, index) in acf.acf.sponsor_section"
                    :key="index + 'spon'"
                    :style="{
                    backgroundImage:
                        'url(https://ocs-sport.ams3.digitaloceanspaces.com/cpt/2026/06/finalover.png)'
                    }"
                >
                    <div class="overlay-content">
                        <h1 class="sponTitle">{{ spon.sponsor_title }}</h1>

                        <h2 class="sponText" v-html="spon.sponsor_sub_text"></h2>

                        <p class="sponPara" v-html="spon.sponsor_points"></p>
                    </div>
                </b-col>
            </b-row>
            <b-row class="Below1200">
                <b-col
                    lg="12"
                    class="sponCol"
                    v-for="(spon, index) in acf.acf.sponsor_section"
                    :key="index + 'spon'"
                    :style="{
                    backgroundImage:
                        'url(https://ocs-sport.ams3.digitaloceanspaces.com/cpt/2026/06/finalover.png)'
                    }"
                >
                    <div class="overlay-content">
                        <h1 class="sponTitle">{{ spon.sponsor_title }}</h1>

                        <h2 class="sponText" v-html="spon.sponsor_sub_text"></h2>

                        <p class="sponPara" v-html="spon.sponsor_points"></p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
    <!-- Banner at the bottom -->
    <div class="backgroundGreen hideMob">
        <div class="row container rowClass">
            <b-col v-for="(top, index) in acf.acf.banner_row_bottom" :key="index + 'topRow'">
                <div class="bannerBlock">
                    <b-row>
                        <b-col lg='4'>
                            <img class="bannerImage" :src="top.image">
                        </b-col>
                        <b-col lg='8'>
                            <h1 class="bannerTitle">{{top.title}}</h1>
                            <h2 class="bannerText-b">{{top.text}}</h2>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
export default {
  name: 'Hotel Planner Page',
  components: {
  },
  data: function() {
    return {
      acf: [],
      acfMessage:''
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
    scroll() {
      var score = document.getElementById("sponsorBlo");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/1380"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
    img.eventLogo {
        width: 250px;
        margin: auto;
        display: block;
        padding-top: 45px;
    }
    .AllbuttonsNone:disabled {
        background-color: #d3d3d3 !important;
        color: #888 !important;
        cursor: not-allowed;
        opacity: 0.7;
    }
    html {
        scroll-behavior: smooth!important;
    }
    a.partner {
        text-align: center;
        margin: auto;
        display: block;
        padding-bottom: 30px;
        color: green;
    }
    .ticketSec {
        background-repeat: no-repeat;
    }
    h1.heading.whythismatters {
        color: #fff;
        padding-bottom: 0!important;
    }
    .backgroundTicketWhite {
        background-color: #fff;
        padding: 15px;
        height: 270px;
    }
    p.eventLineOne {
        color: #000000;
        font-size: 15px;
        text-align: center;
        margin-bottom: 0;
        padding-top: 15px;
    }
    p.eventLineTwo {
        color: #000000;
        font-size: 15px;
        text-align: center;
    }
    h1.eventTitle {
        text-align: center;
        font-weight: bold;
        color: #062606;
        font-size: 18px;
        padding-top: 15px;
    }
    img.eventImage {
        width: 100px;
        text-align: center;
        margin: auto;
        display: block;
    }
    .ticketCol {
        height: 200px;
        background-repeat: no-repeat;   
        background-position: center;
        background-size: cover;
    }
    .ticktText {
        color: #000000;
        font-size: 15px;
    }
    p.ticketPara {
        color: #000000;
        font-size: 15px;
    }
    .TicketTitle {
        color: #45a473;
        padding-top: 30px;
        font-size: 30px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
    }
    .whiteback {
        background-color: #fff;
        padding: 30px;
        padding-top: 5px;
        height: 325px;
        margin-bottom: 60px;
    }
    .sponCol {
        position: relative;
        background-size: cover;
        background-position: center;
        overflow: hidden;
    }

    /* Overlay layer */
    .sponCol::before {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.5); /* dark overlay */
        z-index: 1;
    }

    /* Content above overlay */
    .overlay-content {
        position: relative;
        z-index: 2;
        color: #fff;
    }
    ::v-deep ::marker {
        color: #45a473;
    }
    .sponCol {
        height: 400px;
        margin: 10px;
    }
    ::v-deep ul {
        padding-left: 15px!important;
    }
    .greybackground {
        background-color: #ebebeb;
        padding-bottom: 50px;
    }
    .sponTitle {
        color: #fff;
        padding-top: 30px;
        color: #fff;
        font-size: 30px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
    }
    .sponText {
        color: #fff;
        color: #fff;
        font-size: 15px;
        padding-top: 10px;
        padding-bottom: 20px;
    }
    .sponPara {
        color: #fff;
        font-size: 15px;
    }
    .rowClass {
        margin: auto;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .bannerImage {
        width: 100px;
    }
    h1.bannerTitle {
        color: #fff;
        font-weight: 600;
        font-size: 25px;
        margin-top: 15px;
    }
    h2.bannerText-b {
        color: #fff;
        font-size: 10px;
    }

    .backgroundGreen {
        background-color: rgb(6, 38, 6);
    }
    .newbtn {
        background-color: transparent!important;
        border: 1px solid!important;
        left: 0!important
    }
    .AllbuttonsNone {
        width: 272px;
        height: 52px;
        background: #727272;
        /* color: #081C3F; */
        color: #fff;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        border-radius: 0px;
        border: 0px solid #45a473;
        font-size: 18px;
        transition: all 0.4s ease;
        /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
        position: relative;
        top: 110px;
        cursor: not-allowed;
    }
    .Allbuttons {
        width: 272px;
        height: 52px;
        background: #45a473;
        /* color: #081C3F; */
        color: #fff;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        border-radius: 0px;
        border: 0px solid #45a473;
        font-size: 18px;
        transition: all 0.4s ease;
        /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
        transition: all 350ms cubic-bezier(.37, 0, .63, 1);
        position: relative;
        top: 110px;
        /* left: 70px; */
    }
    .Allbuttons:hover {
        width: 272px;
        height: 52px;
        background-color: #081C3F!important;
        background: #081C3F!important;
        color: #fff!important;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        border-radius: 0px;
        border: 1px solid #E8E8E8;
        transform: translateY(-10px);
        position: relative;
        top: 110px;
        /* left: 70px; */
    }
    img.trophyImage {
        width: 160px;
        vertical-align: middle;
        float: right;
        margin-right: 100px;
        /* margin-top: 60px; */
    }
    span.englishColors {
        color: #45a473;
        font-size: 120px;
    }
    .BannerText {
        font-size: 30px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .aboutImage {
        width: 100%;
    }
    .majorHeading {
        color: #FFFFFF;
        font-size: 70px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        position: relative;
        top: 100px;
    }
    .subHeading {
        color: #FFFFFF;
        font-size: 30px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        position: relative;
        top: 100px;
        padding-bottom: 20px;
    }
    .paraHeading {
        color: #FFFFFF;
        font-size: 20px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        position: relative;
        top: 100px;
    }
    .para{
        color: #000000;
        font-size: 25px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        text-align: center;
        padding-bottom: 30px;
    }
    .banner {
        width: 100%;
        height: 770px;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .blueBanner {
        background-color: #45a473;
        color: #fff;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .backgroundGrey {
        background-color: #F2F2F2;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    h1.heading {
        color: rgb(6, 38, 6);;
        font-size: 36px;
        /* font-weight: bold; */
        padding-bottom: 50px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
        text-align: center;
        padding-top: 50px;
    }
    p {
        font-size: 18px;
        color: #081C3F;
    }
    .pad {
        padding-top: 100px;
        padding-bottom: 100px;
    }
    @media only screen and (max-width: 1366px) {
        .banner {
            /* height: 512px; */
        }
        .majorHeading {
            color: #FFFFFF;
            font-size: 65px;
            font-weight: bold;
            position: relative;
            top: 120px;
        }
        .bannerImage {
            width: 70px;
        }
        .sponCol[data-v-1b71e398] {
            height: 450px;
            margin: 10px;
        }
    }
    @media only screen and (min-width: 1201px) {
        .Below1200 {
            display: none;
        }
    }
    @media only screen and (max-width: 1199px) {
        .majorHeading {
            /* display: none; */
        }
        .hideMob {
            display: none;
        }
        .Above1201 {
            display: none;
        }

    }
    @media only screen and (max-width: 510px) {
        img.trophyImage{
            width: 160px;
            vertical-align: middle;
            float: right;
            margin-right: 100px;
            /* margin-top: 60px; */
            display: none;
        }
        .banner {
            width: 100%;
            /* height: 160px; */
            background-repeat: no-repeat;
            background-size: cover;
        }
        .pad {
            padding-top: 30px;
            padding-bottom: 30px;
        }
        h1.heading {
            padding-top: 20px;
            color: #081C3F;
            font-size: 36px;
            /* font-weight: bold; */
            padding-bottom: 30px;
            font-family: "brown-pro-condensed", sans-serif;
            font-weight: 800;
            font-style: normal;
        }
    }
</style>
